import React, { FC, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Preview } from './Preview';
import { PreviewStepProps } from 'components/shared/dialogs/StepModal/StepModal.types';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearStudentRegisterInformation,
  fetchStudentRegisterList,
  fetchStudentRegisterPreview,
  getImportPreview,
  getImportToken,
  isImportLoading,
  postStudentRegisterConfirm,
} from 'store/institutions';


export const PreviewContainer: FC<PreviewStepProps> = (props) => {
  const dispatch: (...params: any) => Promise<any> = useDispatch();
  const importToken = useSelector(getImportToken);
  const { id } = useParams<{ id: string }>();
  const importPreview = useSelector(getImportPreview);
  const isPreviewLoading = useSelector(isImportLoading);

  const handleImportError = useCallback(
    (response) => {
      if (!response?.error) {
        return false;
      }

      if (response.payload?.status === 404) {
        dispatch(clearStudentRegisterInformation());
      }

      props.onFailure(response.payload?.response?.error || 'ERROR.NOT-FOUND');
      return true;
    },
    [dispatch, props],
  );

  const fetchPreview = useCallback(() => {
    return dispatch(fetchStudentRegisterPreview(importToken, id)).then((response) => {
      handleImportError(response);
      return response;
    });
  }, [dispatch, handleImportError, importToken, id]);

  const postConfirm = useCallback(() => {
    return dispatch(postStudentRegisterConfirm(importToken, id)).then((response) => {
      handleImportError(response);
      return response;
    });
  }, [dispatch, handleImportError, importToken, id]);

  const redirectToList = () => {
    dispatch(fetchStudentRegisterList(id));
    dispatch(clearStudentRegisterInformation());
    props.onClose(true);
  };

  return (
    <Preview
      goBack={props.goBack}
      previewRecords={importPreview.recordsPreview}
      loading={isPreviewLoading}
      totalNumber={importPreview.totalNumber}
      identificationNumberNotPesel={importPreview.identificationNumberNotPesel}
      fetchStudentRegisterPreview={fetchPreview}
      postStudentRegisterConfirm={postConfirm}
      redirectToList={redirectToList}
      columns={props.columns}
    />
  );
};
